import InvitationPaneForm from '../../components/authentication/InvitationPaneForm'
import { connect } from 'react-redux'
import { IChangePasswordObj, IStoreState } from '../../types'
import { RouteComponentProps } from 'react-router'
import { changePassword, checkToken, acceptTeamInvite } from '../../state/actions/auth'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<{ token: string }>) {
  return {
    ...ownProps,
    ...state.authorization
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    handleSubmit: (ChangePasswordObj: IChangePasswordObj) => dispatch(changePassword(ChangePasswordObj)),
    handleCheckToken: (token: string) => dispatch(checkToken(token)),
    acceptTeamInvite: (userId: string, organizationId: string) => dispatch(acceptTeamInvite(userId, organizationId))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvitationPaneForm)



// WEBPACK FOOTER //
// ./src/containers/auth/InvitationPaneForm.ts